<template>
<div>
    <!-- modal -->
    <b-modal id="jobReminderCriterionFormModal" centered size="lg" no-close-on-backdrop ref="jobReminderCriterionFormModal" :title=" $t('jobReminderCriterion.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-form>
                <label for="job-reminder-criterion-module-input">{{ $t('jobReminderCriterion.module') }}</label>
                <b-form-group>
                    <b-form>
                        <validation-provider :name=" $t('jobReminderCriterion.module')" :rules="{ excluded:0}" v-slot="{ errors }">
                        <b-form-select size="sm" v-model="moduleSelect" value-field="id" text-field="name" :options="moduleOption" />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-form-group>
                <label for="job-reminder-criterion-name-input">{{ $t('jobReminderCriterion.name') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('jobReminderCriterion.name')" rules="required">
                        <b-form-input id="job_status-name-input" v-model="jobReminderCriterionName" maxlength="50" size="sm" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getJobReminderCriterionList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            jobReminderCriterionName: '',
            moduleSelect: 0,
            moduleOption: [],
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['jobReminderCriterionFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'JobReminderCriterion'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.jobReminderCriterionName = response.data.jobReminderCriterion.name
                    this.moduleOption = response.data.moduleList
                    this.moduleOption.splice(0, 0, this.$nullSelected())
                    if (response.data.jobReminderCriterion.moduleId > 0) {
                        this.moduleSelect = response.data.jobReminderCriterion.moduleId
                    }
                } else {
                    this.$bvModal.hide('jobReminderCriterionFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.jobReminderCriterionName,
                moduleId: this.moduleSelect
            }
            const controller = {
                name: 'JobReminderCriterion'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('jobReminderCriterionFormModal')
                            this.getJobReminderCriterionList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
